import React from "react";
import HorizontalLoader from "../../common/loading-widgets/HorizontalLoader";
import WaitForData from "../../common/data-fetching/WaitForData";
import ReportProblemOutlined from "@material-ui/icons/ReportProblemOutlined";
import useTranslationAdmin from "../useTranslationAdmin";
import useShowLoader from "../../common/loading-widgets/useShowLoader";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import PageSubtitle from "../../common/widgets/PageSubtitle";
import CountLineChart from "./CountLineChart";
import useQueryJobPublicationCountByDate from "./useQueryJobPublicationCountByDate";

export default function JobPublicationCountByDateItem(/*props*/) {
  const { t, loading: tLoading } = useTranslationAdmin();
  useShowLoader(tLoading, "JobPublicationCountByDateItem");

  const { data, loading, errors } = useQueryJobPublicationCountByDate();

  return (
    <HorizontalLoader>
      <WaitForData
        loading={loading}
        errors={errors}
        onError={() => <ReportProblemOutlined className="LoadingError" />}
        onLoaded={() => (
          <div className="JobPublicationCountByDateItem">
            <PageSubtitle
              colTitle={t(
                "admin:admin_dashboard_job_count_by_date_title"
              )}
            />
            <Row>
              <Col>
                <CountLineChart data={data} />
              </Col>
            </Row>
          </div>
        )}
      />
    </HorizontalLoader>
  );
}
